<template>
  <div>
    <b-form-group
      label="Problème de dimensionnement "
      label-cols="4"
      :label-for="'work' + id + '_sizingProblem'"
    >
      <b-form-radio-group
        :numberWork="'work' + numberWork + '_sizingProblem'"
        buttons
        v-model="getForm['work' + numberWork + '_sizingProblem']"
        :options="options"
        size="lg"
        button-variant="outline-info"
        :name="'work' + numberWork + '_sizingProblem'"
      />
    </b-form-group>

    <b-form-group
      label="Commentaires "
      label-cols="4"
      :label-for="'work' + id + '_commentSizingProblem'"
    >
      <b-form-textarea
        :numberWork="'work' + numberWork + '_commentSizingProblem'"
        :name="'work' + numberWork + '_commentSizingProblem'"
        class="form-control"
        v-model="getForm['work' + numberWork + '_commentSizingProblem']"
        rows="3"
        max-rows="6"
        :maxlength="$MAX_2000"
      />
    </b-form-group>

    <b-form-group
      label="Problème état des ouvrages de rétention "
      label-cols="4"
      :label-for="'work' + id + '_stateOfRetentionStructure'"
    >
      <b-form-radio-group
        :numberWork="'work' + numberWork + '_stateOfRetentionStructure'"
        buttons
        v-model="getForm['work' + numberWork + '_stateOfRetentionStructure']"
        :options="options"
        size="lg"
        button-variant="outline-info"
        :name="'work' + numberWork + '_stateOfRetentionStructure'"
      />
    </b-form-group>
    <b-form-group
      label="Commentaires "
      label-cols="4"
      :label-for="'work' + id + '_commentstateOfRetentionStructure'"
    >
      <b-form-textarea
        :numberWork="'work' + numberWork + '_commentstateOfRetentionStructure'"
        :name="'work' + numberWork + '_commentstateOfRetentionStructure'"
        class="form-control"
        v-model="getForm['work' + numberWork + '_commentstateOfRetentionStructure']"
        rows="3"
        max-rows="6"
        :maxlength="$MAX_2000"
      />
    </b-form-group>
    <b-form-checkbox
      plain
      :id="'work' + numberWork + '_missingDocuments'"
      :name="'work' + numberWork + '_missingDocuments'"
      v-model="getForm['work' + numberWork + '_missingDocuments']"
      class="form-group row"
      value="1"
      unchecked-value="null"
    >Documents manquants</b-form-checkbox>

    <b-form-group
      label="Commentaires "
      label-cols="4"
      :label-for="'work' + id + '_commentMissingDocuments'"
    >
      <b-form-textarea
        :id="'work' + numberWork + '_commentMissingDocuments'"
        :name="'work' + numberWork + '_commentMissingDocuments'"
        class="form-control"
        v-model="getForm['work' + numberWork + '_commentMissingDocuments']"
        rows="3"
        max-rows="6"
        size="lg"
        :maxlength="$MAX_2000"
      />
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'SpecificWorkVpt',
  props: {
    numberWork: { type: Number, required: true },
  },
  computed: {
    ...mapGetters(['getForm']),
  },
  data: () => ({
    id: '',
    options: [
      { text: 'Oui', value: 'oui' },
      { text: 'Non', value: 'non' },
      { text: 'Indéterminé', value: 'impossible' },
    ],
  }),
};
</script>
